import { Component, Input, OnInit } from '@angular/core';
import { ModalController, PopoverController } from '@ionic/angular';
import { ViewController } from '@ionic/core';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';

@Component({
  selector: 'app-vip-terms',
  templateUrl: './popover-vipterms.component.html',
  styleUrls: ['./popover-vipterms.component.scss'],
})
export class VipTermsComponent implements OnInit {

  @Input() data: any;

  constructor(
    public appLinks: AppLinksService,
    public popoverController: PopoverController
  ){
  }

  ngOnInit(): void {

  }

  public onClosePopover() {
    this.popoverController.dismiss();
    if (this.data.onCloseFunc) {
      let func = this.data.onCloseFunc;
      func();
    }
  }

  public openLink(url) {
    if('expectResult' in this.data && !!this.data.expectResult) this.onClosePopover();
    return this.appLinks.openExternalPage(url);
  }

}
